const collection = {
    slug: "comme-des-garcons-2019ss-quiet-collection-cutting-guide",
    metaTitle:
      "COMME des GARCONS 2019SSとは｜静かなコレクションとカッティングの買取・レンタルガイド",
    metaDescription:
      "COMME des GARCONS 2019SSを解説。川久保玲が『静かなコレクション』と表現した、過去10年のショーピース的表現から落ち着いた方向へ向かったシーズン。カッティング、クラシックな服へのハサミ、異素材切り替え、ドッキング、こぶ状の造形、リボン状ディテールまで読み解き、COMME des GARCONS買取・レンタル導線へ案内します。",
    metaKeywords:
      "COMME des GARCONS 2019SS,COMME des GARÇONS 2019SS,コムデギャルソン 2019SS,コムデギャルソン 2019春夏,コムデギャルソン 静かなコレクション,COMME des GARCONS 静かなコレクション,コムデギャルソン カッティング,COMME des GARCONS カッティング,コムデギャルソン ハサミ,コムデギャルソン ドッキング,コムデギャルソン 異素材切り替え,コムデギャルソン こぶ,コムデギャルソン リボン,川久保玲 静かなコレクション,川久保玲 カッティング,コムデギャルソン ジャケット,コムデギャルソン テーラード,コムデギャルソン 名作,COMME des GARCONS 名作,コムデギャルソン アーカイブ,COMME des GARCONS アーカイブ,コムデギャルソン 買取,COMME des GARCONS 買取,コムデギャルソン レンタル,COMME des GARCONS レンタル,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/comme-des-garcons-2019ss-quiet-collection-cutting-guide",
    heroImage:
      "media/archive_fashion/archive21.png",
    heroImageAlt:
      "COMME des GARCONS 2019SS 静かなコレクションとカッティングを解説するEnclopediaアーカイブガイド画像",
    heroNumber: "21 / QUIET COLLECTION",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "COMME des GARCONS 2019SS『Quiet Collection / Cutting』",
    lead:
      "COMME des GARCONS 2019SS。\n\n川久保玲はこのシーズンを、“静かなコレクション”と表現しました。\n\nここでの“静か”とは、過去10年ほど続いていた芸術作品のようなショーピース、巨大な造形、過剰な視覚表現と比べて、デザインが落ち着いているという意味で捉えるのが自然です。\nそれ以上に読み込みすぎる必要はありません。\n\nただし、落ち着いているから弱いわけではありません。\n全体として最も目立つのは、カッティングです。\n上質な素材、仕立てのよいクラシックな服、テーラード、ジャケット、ジャンプスーツ。\n完成された服にハサミを入れることで、静かな見た目の中に強い違和感を作っています。\n\n一方で、個別のアイテムに目を向けると、異素材切り替え、ドッキング、Body Meets Dressを思わせるこぶ状の造形、生地を余らせて結ぶようなリボン状ディテールも見られます。\n\nEnclopediaでは、この2019SSを、過剰なショーピースから服そのものへ少し引き戻しながら、カッティングを中心にCOMME des GARCONSらしい違和感を残したシーズンとして読み解きます。",
    keywordLine: [
      "quiet collection",
      "cutting",
      "tailoring",
      "comme des garcons buyback",
    ],
    thesis:
      "2019SSの重要性は、過去10年ほどのショーピース的な過剰さに比べて落ち着いたデザインへ向かいながら、カッティングを中心に、個別アイテムでは異素材切り替え、ドッキング、こぶ状の造形、リボン状ディテールを用いて、静かな中にもCOMME des GARCONSらしい違和感を残した点にあります。",
    whyTitle:
      "なぜCOMME des GARCONS 2019SSは、“静かなコレクション”だったのか。",
    whyBody:
      "COMME des GARCONSの2019SSを読むうえで、最初に整理すべきなのは“静かなコレクション”という言葉です。\n\nこれは、精神性や思想を過剰に読み込むよりも、まずは見た目の方向性として捉えるべきです。\n過去10年ほど続いていた、巨大で芸術作品のようなショーピースの流れに比べると、2019SSは明らかに落ち着いています。\n\nしかし、落ち着いていることと、普通であることは違います。\nこのシーズンの主役は、カッティングです。\n\n仕立てのよいクラシックな服にハサミを入れる。\nウエストで切る。\nジグザグに切る。\nサイドへスリットのように切り込みを入れる。\n\n完成された服の中に、切断という違和感を置く。\nその行為が、2019SSの中心にあります。\n\n同時に、ショー全体を細かく見ると、カッティングだけではありません。\n個別のアイテムには、異素材切り替えやドッキング、身体の外側に布が膨らむこぶ状の造形、生地を余らせて結ぶようなリボン状のディテールも見られます。\n\nただし、それらは主題として前面に出るというより、カッティングを中心とした静かなコレクションの中に残された、COMME des GARCONSらしい造形の記憶として読むべきです。\n\nEnclopediaでは、この文脈を入口に、COMME des GARCONS 2019SSの買取相談、COMME des GARCONS全体のレンタル体験、そしてブランド理解へつなげます。",
    pillars: [
      {
        number: "01",
        title: "CUTTING AS MAIN DESIGN",
        text:
          "2019SSで最も目立つデザイン要素はカッティングです。上質な素材やクラシックな服にハサミを入れ、完成された服の中に静かな違和感を作っています。",
      },
      {
        number: "02",
        title: "QUIET, NOT MINIMAL",
        text:
          "静かなコレクションとは、ミニマルなコレクションという意味ではありません。過去10年のショーピース的な過剰さに比べて、全体の見え方が落ち着いているという意味です。",
      },
      {
        number: "03",
        title: "DETAILS IN EACH PIECE",
        text:
          "個別アイテムでは、異素材切り替え、ドッキング、こぶ状の造形、余った生地を結ぶようなリボン状ディテールも見られます。静かな中にもCOMME des GARCONSの語彙が残っています。",
      },
    ],
    readingTitle:
      "カッティング、静けさ、異素材切り替え、こぶ、リボンから読むCOMME des GARCONS 2019SS。",
    readingIntro:
      "このシーズンは、カッティングだけで説明すると狭くなります。ただし、異素材切り替えやこぶ状の造形を主題として大きく扱いすぎてもズレます。2019SSは、全体としては過去のショーピースに比べて落ち着いた“静かなコレクション”であり、その中心にカッティングがあり、個別アイテムにCOMME des GARCONSらしい構造の癖が残るシーズンです。",
    observations: [
      {
        index: "01",
        title:
          "“静かなコレクション”とは、落ち着いた見え方のことである",
        text:
          "2019SSを語るうえで、“静かなコレクション”という言葉は重要です。\n\nただし、それを必要以上に精神的な意味へ広げる必要はありません。\nここでの静けさは、過去10年ほど続いていた巨大なショーピース、芸術作品のような造形、過剰なシルエットと比べて、デザインの見え方が落ち着いているという意味です。\n\nCOMME des GARCONSにしては静か。\nしかし、普通ではない。\n\nこの距離感が2019SSを読むうえで最も重要です。",
      },
      {
        index: "02",
        title:
          "全体の主役は、やはりカッティングである",
        text:
          "ショー全体で最も目立つデザイン要素は、カッティングです。\n\n上質な素材。\n仕立てのよいクラシックな服。\nテーラード、ジャケット、ジャンプスーツ。\nそこにハサミを入れる。\n\nウエストで切るもの、ジグザグに切るもの、サイドにスリットのような切り込みを入れるもの。\nカットの位置はルックによって異なりますが、共通しているのは、完成された服の秩序を部分的に崩していることです。\n\n派手に壊すのではなく、静かに切る。\nそれが2019SSの中心です。",
      },
      {
        index: "03",
        title:
          "クラシックな服だからこそ、切断が効いている",
        text:
          "2019SSでは、ベースにある服が比較的クラシックです。\nテーラード、ジャケット、ジャンプスーツ、上質な素材、刺繍生地。\n\nだからこそ、カットが強く見えます。\n元の服が荒々しいものなら、切断はただのダメージに見えてしまう。\nしかし、仕立てのよい服にハサミを入れることで、切断はデザインとして明確になります。\n\n整った服に、不整合を入れる。\nこの構造が、2019SSの静かな強さです。",
      },
      {
        index: "04",
        title:
          "異素材切り替えとドッキングは、個別アイテムに現れる再構成の要素である",
        text:
          "2019SSでは、カッティングだけでなく、異素材切り替えやドッキングのような構成も見られます。\n\nただし、それをシーズン全体の主題として大きく語りすぎるとズレます。\nあくまで主軸はカッティングです。\n\n異素材切り替えやドッキングは、個別アイテムにフォーカスしたときに見えてくる要素です。\n切るだけではなく、別の素材や服の要素を接続する。\n\nCOMME des GARCONSらしい再構成の癖が、静かなコレクションの中にも残っています。",
      },
      {
        index: "05",
        title:
          "Body Meets Dressを思わせるこぶ状の造形は、過去の記憶として現れる",
        text:
          "一部のルックには、Body Meets Dressを思わせるこぶ状の造形も見られます。\n\nただし、2019SSは1997SSの再演ではありません。\n身体そのものを劇的に変形させることが主題ではなく、比較的落ち着いた服の中に、過去のCOMME des GARCONSの造形語彙が部分的に現れていると見るべきです。\n\nつまり、こぶはシーズン全体の中心ではありません。\nしかし、COMME des GARCONSの過去を知っている人にとっては、見逃せないディテールです。\n\n静かな中に、過去の強い造形が小さく残っている。\nそこが2019SSの面白さです。",
      },
      {
        index: "06",
        title:
          "余った生地を結ぶリボン状ディテールは、装飾であり構造でもある",
        text:
          "個別のアイテムには、生地を余らせて結ぶようなリボン状のディテールも見られます。\n\nこれは単なる可愛らしい装飾として見るより、余った布の処理、布の動き、服の構造の一部として見る方が自然です。\n\n切られた布、余った布、結ばれた布。\n服の中で布が完璧に収まらず、外側に余剰として現れる。\n\n2019SSのリボン状ディテールは、静かなコレクションの中に残る、布そのものの存在感です。",
      },
      {
        index: "07",
        title:
          "ボディスーツは、切られた服の下に新しい肌を作る",
        text:
          "カットされた服の隙間からは、タトゥーのようなボディスーツがのぞきます。\n\nこれは単なるインナーではありません。\n切られた服の下に、もう一枚の肌があるように見える。\n\n服にハサミを入れることで、内側が見える。\nしかしそこにあるのは素肌ではなく、ロゴや数字、ローズのようなモチーフを持つ薄い素材です。\n\n切断によって露出するのは、身体そのものではなく、作られた新しい肌です。\nここにもCOMME des GARCONSらしい距離感があります。",
      },
      {
        index: "08",
        title:
          "トレンチのロールや蛇腹は、纏い方の余地を残す",
        text:
          "トレンチコートの一部には、アシンメトリーに長くなった身頃をロール状にまとめたり、蛇腹に畳んだりして、ベルトで留めるような仕様も見られます。\n\nこれは、完成された一つの形を提示するというより、着方や纏い方に余地を残すディテールです。\n\n布をどうまとめるか。\nどこで留めるか。\nどう身体の周囲に配置するか。\n\n2019SSは落ち着いた見え方でありながら、個別のアイテムには、着る人の操作が入る余白もあります。",
      },
      {
        index: "09",
        title:
          "2018SSの過剰さの後に見ると、2019SSの静けさが分かる",
        text:
          "2018SS『Multi-dimensional Graffiti』では、複数のアーティスト作品が巨大な立体服の上で衝突していました。\n身体から大きく離れた造形、過剰なイメージ、強い視覚性。\n\nその直後に2019SSを見ると、静かなコレクションという意味が分かりやすくなります。\n\n2019SSは、同じような過剰さで押し切るシーズンではありません。\n服の見え方は落ち着き、カッティングを中心に、個別アイテムの構造へ視線が向かいます。\n\nこの落ち着きが、2019SSの特徴です。",
      },
      {
        index: "10",
        title:
          "買取で見るべきなのは、カッティングの強さと個別ディテールの有無",
        text:
          "COMME des GARCONS 2019SSの買取では、単に“シンプルな服”として見ると価値を見誤ります。\n\nどこにカットが入っているか。\nカットが服の構造をどう変えているか。\n異素材切り替えやドッキングがあるか。\nこぶ状の造形、リボン状ディテール、ボディスーツとの関係があるか。\n2019SSらしい落ち着いた見え方と、COMME des GARCONSらしい違和感が両立しているか。\n\nEnclopediaでは、COMME des GARCONSの服を単なるブランド古着としてではなく、川久保玲のコレクション背景と現在の需要まで含めて確認します。",
      },
      {
        index: "11",
        title:
          "レンタルで分かるのは、静かな服の中にある切断と余白",
        text:
          "2019SSの服は、画像で見ると比較的静かに見えるかもしれません。\nしかし実際に着ると、切られた位置、布の落ち方、身体との距離、異素材の切り替わり、余った布の動きが分かります。\n\n大きな造形ではなく、服の中にある小さな違和感を身体で理解する。\n\nEnclopediaでは、記事で背景を読み、レンタルで身体感覚として確かめる導線を作ります。",
      },
    ],
    quote:
      "COMME des GARCONS 2019SSは、過剰なショーピースの後に現れた静かなコレクションです。しかしその静けさの中心には、完成された服にハサミを入れるカッティングの強さがあります。",
    perspectiveTitle:
      "Enclopediaは、COMME des GARCONSを“奇抜な服”ではなく“静かな違和感まで読むアーカイブ”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "2019SSの静けさ、カッティング、個別アイテムに現れるドッキングやこぶ状の造形を手がかりに、COMME des GARCONSの服の見方を整理します。",
      },
      {
        number: "02",
        title: "EXPERIENCE",
        text:
          "COMME des GARCONSのカッティングは、実際に着ることで理解が深まります。切られた位置、布の落ち方、身体との距離をレンタルで体験できます。",
      },
      {
        number: "03",
        title: "ARCHIVE VALUE",
        text:
          "シーズン背景、カッティング、素材、仕立て、個別ディテール、状態を知ることで、COMME des GARCONSの一着がアーカイブとしてどう評価されるのかが見えてきます。",
      },
    ],
    experienceTitle:
      "COMME des GARCONS 2019SSを売る前に、その一着がどの文脈にあるかを確認する。",
    experienceBody:
      "COMME des GARCONS 2019SSの買取では、ブランド名だけでなく、シーズン、テーマ、カッティング、素材、状態、サイズ、現在の需要が重要です。\n今回の記事では“静かなコレクション”とカッティングを中心に解説していますが、個別アイテムでは異素材切り替え、ドッキング、こぶ状の造形、リボン状ディテール、ボディスーツとの関係も確認すべき要素になります。\n\nEnclopediaが見ているのは2019SSだけではありません。\nCOMME des GARCONS、COMME des GARCONS HOMME PLUS、JUNYA WATANABE、noir kei ninomiya、BLACK COMME des GARCONSなど、コムデギャルソン周辺のアーカイブ全体を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n\n2019SSを知ることは、COMME des GARCONSの服が持つ“静かな強さ”と“構造の価値”を見極める入口になります。",
    experienceItems: [
      "COMME des GARCONS 2019SSのタグ・シーズンを確認する",
      "静かなコレクションに近いカッティング、テーラード、ジャケット、ジャンプスーツを撮影する",
      "ウエストの切断、ジグザグのカット、サイドスリット、構造的な切り込みを確認する",
      "異素材切り替え、ドッキング、こぶ状の造形、リボン状ディテールの有無を確認する",
      "ボディスーツ、トレンチのロール状・蛇腹状ディテール、ベルト留めの仕様を確認する",
      "サイズ・状態・購入時期・付属品を確認する",
      "2019SSか不明な場合もLINEで写真を送る",
    ],
    archiveItemsTitle:
      "2019SSを入口に、COMME des GARCONSの買取・レンタルへ。",
    archiveItemsBody:
      "Enclopediaでは、COMME des GARCONSを単なるブランド古着としてではなく、川久保玲のデザイン哲学、シーズン背景、カッティング、個別ディテール、現在の需要まで含めて見ています。この記事で2019SSの重要性に触れた方は、所有しているCOMME des GARCONSの一着も、まずはLINEで気軽にご相談ください。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "COMME des GARCONS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons",
        productImage: "",
        text:
          "COMME des GARCONS 2019SSを含むジャケット、ドレス、ジャンプスーツ、テーラード、カッティングやドッキングの強いアーカイブまで。コムデギャルソンの買取対象と査定視点を確認できます。",
      },
      {
        label: "RENTAL FOCUS 02",
        title: "静かなコレクションを読んだら、次はCOMME des GARCONSの価値を相談する。",
        productPath:
          "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "COMME des GARCONS 2019SSは、過去10年のショーピース的な過剰さに比べて落ち着いた見え方を持ちながら、カッティングを中心に強い違和感を残したシーズンです。\nEnclopediaでは、2019SSの買取相談を入口に、COMME des GARCONS全体のレンタル体験やブランド一覧へつなげます。\nまずはLINEでタグ・品質表示・全体写真をお送りください。"
      },
      {
        label: "BRAND FOCUS 03",
        title: "COMME des GARCONSブランド一覧へ",
        productPath:
          "/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
        productImage: "",
        text:
          "2019SSだけでなく、COMME des GARCONS、COMME des GARCONS HOMME PLUS、JUNYA WATANABE、BLACK COMME des GARCONSなどの取り扱いアイテムを確認できます。",
      },
    ],
  };
  
  export default collection;